export default "__VITE_ASSET__cGFoh6PS__"